import React from "react";
import './CheckboxOption.css';

const CheckboxOption = ({ label, checked, category = "default", onChange }) => {
    return (
        <label className={`checkbox-option d-flex align-items-center mb-2 ${category}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
                className="me-3"
            />
            <span>{label}</span>
        </label>
    );
};

export default CheckboxOption;
